/* eslint-disable react/prop-types */
import Skeleton, { SkeletonTheme } from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import { ProjectCard } from "../ProjectCard/ProjectCard";
import "./ProjectsGrid.css";

export const ProjectsGrid = ({ isLoading, error, filteredProjects }) => {
    if (isLoading)
        return (
            <SkeletonTheme baseColor="#202020" highlightColor="#333">
            <div
                className="skeleton-container"
            >
                <div style={{ flex: 1 }}>
                    <Skeleton
                        width={"100%"}
                        borderRadius={"20px"}
                        inline
                        className="skeleton"
                    />
                </div>
                <div style={{ flex: 1 }}>
                    <Skeleton
                        width={"100%"}
                        borderRadius={"20px"}
                        inline
                        className="skeleton"
                    />
                </div>
            </div>
            <div
                className="skeleton-container"
            >
                <div style={{ flex: 1 }}>
                    <Skeleton
                        width={"100%"}
                        borderRadius={"20px"}
                        inline
                        className="skeleton"
                    />
                </div>
                <div style={{ flex: 1 }}>
                    <Skeleton
                        width={"100%"}
                        borderRadius={"20px"}
                        inline
                        className="skeleton"
                    />
                </div>
            </div>
        </SkeletonTheme>
        );
    if (error)
        return <div className="">Oops! An error ocurred: {error.message}</div>;
    return (
        <div className="projects-grid">
            {filteredProjects.map((project) => (
                <ProjectCard key={project.id} project={project} />
            ))}
        </div>
       
    );
};
